module.exports = __webpack_public_path__ + "img/b_2.fdecd9d9.jpg";